import { Injectable } from '@angular/core';

import { EmailServiceProvider } from '@services/email/email-service/email.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { MailsDataProvider } from '@services/email/mails.data.service';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { Mail } from '@models/models';

interface MailData {
	chosenEmail: any;
	chosenContract?: any;
}

interface MessageParametres {
	messageData: Mail;
	contract: any;
	jobId: number;
	mailData: MailData;
	showCcField: boolean;
}

interface DataToSend {
	emailTo: string;
	emailCc: string;
	emailText: string;
	emailSubject: string;
	contractText?: string;
	contractId: number;
	jobId: number;
	templateId: number;
}

interface ContractMailData {
	sendMessageData: DataToSend;
	storedFiles: Array<any>;
	uploadedFiles: Array<any>;
}

@Injectable()
export class ContractsServiceProvider {
	constructor(
		private emailService: EmailServiceProvider,
		private messageService: MessageService,
		private mailsDataService: MailsDataProvider,
		private stringModifierService: StringModifierServiceProvider
	) {}

	setDefaultEmail(emails: Array<any>) {
		if (emails !== undefined && emails !== null && emails.length) {
			return (
				emails.find(
					item => item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE'
				) || {}
			);
		}
		return null;
	}

	errorSendMessage(result, emailTo: string, activeView: string): void {
		const { status, error } = result;
		const { errorTitle, errorMessage } = error;
		if (status >= 400 && status < 500 && errorMessage) {
			if (errorMessage.includes('Email address inactive')) {
				this.messageService.showToaster('e_1', 'generalValidation', emailTo);
			} else if (activeView.includes('JobProfilePage')) {
				this.messageService.showToaster('e_0', 'contract');
			} else if (
				errorMessage.includes('Email text should contain a contract link')
			) {
				this.messageService.showToaster('e_0', 'contract');
			} else {
				this.messageService.showErrorFromBackend(errorTitle, errorMessage);
			}
		} else {
			this.messageService.showToaster('e_0', 'general');
		}
	}

	successSendEmail() {
		this.messageService.showToaster('s_4', 'jobView');
		this.mailsDataService.emitMailUpdateEvent(true);
	}

	gatherDataToSendContract(
		data: MessageParametres,
		isNew: boolean
	): ContractMailData {
		const { messageData, contract, jobId, mailData, showCcField } = data;
		const { attachmentsData } = messageData;
		const { storedFiles, uploadedFiles } = this.emailService.prepareAttachments(
			attachmentsData
		);

		let sendMessageData;
		if (isNew) {
			sendMessageData = this.prepareNewContractMailToSend(
				messageData,
				jobId,
				mailData,
				showCcField,
				contract
			);
		} else {
			sendMessageData = this.prepareExistingContractMailToSend(
				messageData,
				contract,
				jobId,
				mailData,
				showCcField
			);
		}

		return {
			sendMessageData,
			storedFiles,
			uploadedFiles
		};
	}

	prepareContractToSave(updatedContract, chosenContract): any {
		let contract;
		if (updatedContract) {
			contract = updatedContract;
		} else {
			contract = chosenContract;
		}

		if (contract && contract.name) {
			contract.name = this.stringModifierService.cutSelectedText(contract.name);
		}
		return contract;
	}

	private prepareExistingContractMailToSend(
		messageData,
		contract,
		jobId,
		mailData,
		showCcField
	): DataToSend {
		const emailCC2save = showCcField ? messageData.emailCc : '';

		return {
			emailTo: messageData.emailTo,
			emailCc: emailCC2save,
			emailText: messageData.emailText || '',
			emailSubject: messageData.emailSubject,
			contractText: contract.text,
			contractId: contract.id,
			jobId,
			templateId: mailData.chosenEmail.id
		};
	}

	private prepareNewContractMailToSend(
		messageData,
		jobId,
		mailData,
		showCcField,
		updatedContract
	): DataToSend {
		const emailCC2save = showCcField ? messageData.emailCc : '';
		const contract2Save = updatedContract
			? updatedContract.text
			: mailData.chosenContract.text;

		const result: DataToSend = {
			emailTo: messageData.emailTo,
			emailCc: emailCC2save,
			emailText: messageData.emailText || '',
			emailSubject: messageData.emailSubject,
			contractId: mailData.chosenContract
				? mailData.chosenContract.templateId
				: null,
			jobId,
			templateId: mailData.chosenEmail.id
		};

		if (contract2Save) {
			result.contractText = contract2Save;
		}

		return result;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/contract/contracts-service/contracts.service.ts